<template>
  <div class="customAutocomplete">
    <span>
      <h6>{{ label }}</h6>
      <app-tooltip v-if="tooltip">
            <template v-slot:tooltipHeader>
              <slot name="tooltipHeader" />
            </template>
            <template v-slot:tooltipText>
              <slot name="tooltipText" />
            </template>
        </app-tooltip>
    </span>

    <v-autocomplete
      :items="items"
      :value="value"
      color="#000"
      @change="onChange($event)"
    ></v-autocomplete>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    tooltip: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onChange(e) {
      this.$emit('input', e);
    },
  },
};
</script>

<style lang="scss">
  @import "@/styles/variables.scss";

  .customAutocomplete {
    h6 {
      display: inline-block;
      margin-top: 8px;
      margin-bottom: 6px;
    }

    .v-input__slot {
      &:before,
      &:after {
        content: none !important;
      }
    }

    .v-select__slot {
      height: 40px;
      border: 1px solid $field-borders-color;

      input {
        cursor: pointer;
        padding: 9px 10px;
        margin-bottom: 0;
        height: 40px;
        max-height: 40px;
      }

      label {
        position: static;
        display: block;
      }
    }

    .v-text-field__details {
      display: none;
    }
  }
</style>
